var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("header", { style: _vm.headerStyle }),
    _c("section", { staticClass: "form" }, [
      _vm.title
        ? _c(
            "div",
            [
              _c("div", { staticClass: "title" }, [
                _c("h3", [_vm._v(_vm._s(_vm.title))]),
              ]),
              _vm.remark
                ? _c("div", { staticClass: "description" }, [
                    _vm._v(_vm._s(_vm.remark)),
                  ])
                : _vm._e(),
              _c("hr"),
              _c("v-form-render", {
                ref: "vFormRef",
                attrs: {
                  "form-json": _vm.formJson,
                  "form-data": _vm.formData,
                  "option-data": _vm.optionData,
                },
              }),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("提交")]
              ),
            ],
            1
          )
        : !_vm.loading
        ? _c("div", { staticClass: "empty" }, [_vm._v("表单不存在~！🤣 ")])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }